import { type SoccerScore, type TennisScore } from './schemas/ticker';

export const soccerOrIceHockey = {
    goals: [0, 0],
    penaltyShots: [[], []],
    // TODO: this needs not to be saved on ticker, only for event
    penaltyShot: null,
} satisfies SoccerScore;

export const tennis = {
    points: ['0', '0'],
    tiebreak: [0, 0],
    sets: [[0, 0]],
    isFinished: false,
} satisfies TennisScore;
